import React from 'react';
import { Box, Typography } from '@mui/material';

function Page2SubPageC2() {
  return (
    <Box p={4}>
      <Typography variant="h4">Federal</Typography>
    </Box>
  );
}

export default Page2SubPageC2;
